<template>
    <div>
        <vue-plyr v-if="videoShown">
            <video controls
                   autoplay
                   loop
                   :style="makeStyle"
                   style="max-width: 100%; height: auto; max-height: 500px"
                   :data-poster="thumbUrl">
                <source :src="url" type="video/mp4"/>
            </video>
        </vue-plyr>
    </div>

</template>

<script>
  export default {
    props: ['url', 'thumbUrl', 'height'],
    data() {
      return {
        videoShown: true
      }
    },

    computed: {
      makeStyle() {
        if (this.height) {
          return `height: ${this.height}px`
        }

        return null
      }
    },

    watch: {
      url(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.videoShown = false
          this.$nextTick(() => {
            this.videoShown = true
          })
        }
      }
    }
  }
</script>